import React from "react";
import { useRouter } from 'next/router'
import CommonButton from "@/components/common/buttons/CommonButton";

const StaticContent = ({header, children, showButton=true}) => {
  const router = useRouter();
  return (
    <div className={`mb-auto p-8 text-center`}>
      <div className={`
        flex flex-col gap-4
        p-8 mx-auto
      text-primary text-left
      bg-neutral-300 bg-opacity-80
        bg-containw
        w-full md:w-2/3
        rounded-lg
        font-gReg
        overflow-hidden
      `}>
        <h1 className={`leading-10 font-gBold text-center text-[32px]`}>{header}</h1>
        {children}
      </div>
      <div className={`${!showButton && 'hidden '} mx-auto inline-block mt-4`}>
        <CommonButton
          label={"Back"}
          onClick={() => router.back()}
          type="button"
          className="px-8 py-1 mt-4"
        />
      </div>
    </div>
  );
}

export default StaticContent;
